import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Moment from "moment";
import { Container, Content } from "./styles";
import OutsideClickHandler from "react-outside-click-handler";
import AddBackground from "../AddBackground";
import UserEdit from "../UserEdit";
import { FiArrowLeft } from "react-icons/fi";
import { UserType } from "../../types/UserTypes";
import { get_user, remove_user } from "../../services/user";

function UserDetail() {
	const { id } = useParams<any>();
	const history = useHistory();
	const [showEdit, setShowEdit] = useState("hidden");
	const [user, setUser] = useState<UserType>();

	const refresh = async () => {
		try {
			const user = await get_user(id);
			setUser(user.data);
		} catch (error) {
			return error;
		}
	};

	useEffect(() => {
		refresh();
	}, []);

	const afterSubmit = async () => {
		setShowEdit("hidden");
		refresh();
	};

	const handleRemoveUser = async () => {
		try {
			await remove_user(id);
			history.push("/gerenciamento-de-cadastros");
		} catch (error) {
			return error;
		}
	};

	const ProcessData = () => {
		return (
			<tr className='tr-wrapper'>
				<td id='header'>Em Breve</td>
			</tr>
		);
	};

	return (
		<Container>
			<div style={{ display: "flex" }}>
				<p id='header'>
					Administrador <span>Nome</span>
				</p>
			</div>
			<Content>
				<div id='back-button'>
					<Link to='/gerenciamento-de-cadastros'>
						<FiArrowLeft id='svg-icon' />
					</Link>
				</div>

				<div className='top-wrapper'>
					<div className='infos-wrapper'>
						<div className='top-info'>
							<p id='name'>{user?.name}</p>

							<button onClick={() => setShowEdit("show")}>
								EDITAR
							</button>
						</div>

						<div className='bottom-info'>
							<div className='info'>
								<div>
									<p>Processos participados:</p> <p>0</p>
								</div>
								<div>
									<p>Data da criação da conta:</p>{" "}
									<p>
										{Moment(user?.createdAt).format(
											"DD/MM/YYYY",
										)}
									</p>
								</div>
								<div>
									<p>E-mail de cadastro:</p>{" "}
									<p>{user?.email}</p>
								</div>
							</div>

							<div className='info'>
								<div>
									<p>Média de erros:</p> <p>0</p>
								</div>

								<div>
									<p>Cargo:</p>{" "}
									<p>
										{user?.role === 0
											? "Administrador"
											: user?.role === 1
											? "Analista"
											: "Digitador"}
									</p>
								</div>
							</div>
						</div>
					</div>

					<div className='register-management'>
						<p id='reg-title'>Gerencia de cadastro</p>
						<button className='reg-button' id='rec-pass'>
							ENVIAR E-MAIL PARA RECUPERAR SENHA
						</button>

						<button
							className='reg-button'
							id='delete-user'
							onClick={handleRemoveUser}>
							EXCLUIR CADASTRO
						</button>
					</div>
				</div>
				<div className='bottom-wrapper'>
					<div className='process-management'>
						<table>
							<tr className='tr-wrapper' id='tr-title'>
								<th>Processos</th>
								<th>Status</th>
								<th>Recebido</th>
								<th>Tempo de processo</th>
							</tr>

							<ProcessData />
						</table>
					</div>
					<div className='analytics'>
						<p>Análises</p>

						<div className='chart-wrapper'>
							<p>Erros</p>
							<div>
								<p>Em</p>
								<p>Breve</p>
							</div>
						</div>

						<div className='chart-wrapper'>
							<p>Recebidos/Feitos</p>
							<div>
								<p>Em</p>
								<p>Breve</p>
							</div>
						</div>
					</div>
				</div>
			</Content>
			<AddBackground className={showEdit}>
				<OutsideClickHandler
					onOutsideClick={() => setShowEdit("hidden")}>
					<UserEdit
						show={setShowEdit}
						user={user}
						afterSubmit={afterSubmit}
					/>
				</OutsideClickHandler>
			</AddBackground>
		</Container>
	);
}

export default UserDetail;
